export const getTelegramUserId = () => {
    try {
        const user = window?.Telegram?.WebApp?.initDataUnsafe?.user;
        return user?.id ? String(user.id) : null;
    } catch {
        return null;
    }
};

const key = (base, tgUserId) => (tgUserId ? `tg:${tgUserId}:${base}` : base);

export const getAccessToken = () => {
    const tgUserId = getTelegramUserId();
    const scoped = tgUserId ? localStorage.getItem(key('accessToken', tgUserId)) : null;
    return scoped ?? localStorage.getItem('accessToken');
};

export const setAccessToken = (token) => {
    const tgUserId = getTelegramUserId();
    if (tgUserId) {
        localStorage.setItem(key('accessToken', tgUserId), token);
    }
    localStorage.setItem('accessToken', token);
};

export const removeAccessToken = () => {
    const tgUserId = getTelegramUserId();
    if (tgUserId) {
        localStorage.removeItem(key('accessToken', tgUserId));
    }
    localStorage.removeItem('accessToken');
};

export const getRefreshToken = () => {
    const tgUserId = getTelegramUserId();
    const scoped = tgUserId ? localStorage.getItem(key('refreshToken', tgUserId)) : null;
    return scoped ?? localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token) => {
    const tgUserId = getTelegramUserId();
    if (tgUserId) {
        localStorage.setItem(key('refreshToken', tgUserId), token);
    }
    localStorage.setItem('refreshToken', token);
};

export const removeRefreshToken = () => {
    const tgUserId = getTelegramUserId();
    if (tgUserId) {
        localStorage.removeItem(key('refreshToken', tgUserId));
    }
    localStorage.removeItem('refreshToken');
};

export const ensureCurrentUserTokens = () => {
    const tgUserId = getTelegramUserId();
    if (!tgUserId) return; // Outside Telegram or user unknown

    const scopedAccess = localStorage.getItem(key('accessToken', tgUserId));
    const scopedRefresh = localStorage.getItem(key('refreshToken', tgUserId));
    const globalAccess = localStorage.getItem('accessToken');
    const globalRefresh = localStorage.getItem('refreshToken');

    if (scopedAccess) {
        if (globalAccess !== scopedAccess) localStorage.setItem('accessToken', scopedAccess);
    } else if (globalAccess) {
        localStorage.removeItem('accessToken');
    }

    if (scopedRefresh) {
        if (globalRefresh !== scopedRefresh) localStorage.setItem('refreshToken', scopedRefresh);
    } else if (globalRefresh) {
        localStorage.removeItem('refreshToken');
    }
};
